// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { omitKeys } from "@hex-insights/core";
import {
	Announcement,
	CalendarEvent,
	ClassYear,
	ClassYearCategory,
	CourseSection,
	HomeRoomSection,
	Newsletter,
	Post,
	SharingRecord,
	StudentNote,
	User,
	UserGroup,
} from "../../../Utilities";

export type Base = {
	isPublic: SharingRecord["isPublic"];
	includeEmployees: SharingRecord["includeEmployees"];
	includeGuardians: SharingRecord["includeGuardians"];
	includeAllUsersOfPersonTypes: SharingRecord["includeAllUsersOfPersonTypes"];
	announcementID: Announcement["id"] | null;
	calendarEventID: CalendarEvent["id"] | null;
	classYearCategoryIDs: ClassYearCategory["id"][];
	classYearIDs: ClassYear["id"][];
	courseSectionIDs: CourseSection["id"][];
	homeRoomSectionIDs: HomeRoomSection["id"][];
	newsletterID: Newsletter["id"] | null;
	postID: Post["id"] | null;
	studentNoteID: StudentNote["id"] | null;
	userGroupIDs: UserGroup["id"][];
	userIDs: User["id"][];
};

export type Create = Base;

export type CreateRequiredKey = Extract<keyof Create, never>;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	isPublic: false,
	includeEmployees: false,
	includeGuardians: false,
	includeAllUsersOfPersonTypes: false,
	announcementID: null,
	calendarEventID: null,
	classYearCategoryIDs: [],
	classYearIDs: [],
	courseSectionIDs: [],
	homeRoomSectionIDs: [],
	newsletterID: null,
	postID: null,
	studentNoteID: null,
	userGroupIDs: [],
	userIDs: [],
};

export type Detail = Base;

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

export type CreateInAnnouncement = Omit<Create, "announcementID">;

export type CreateInAnnouncementRequiredKey = Exclude<CreateRequiredKey, "announcementID">;

export type CreateInAnnouncementSubset<K extends keyof CreateInAnnouncement = keyof CreateInAnnouncement> = Pick<
	CreateInAnnouncement,
	CreateInAnnouncementRequiredKey | K
>;

export const blankItemInAnnouncement: CreateInAnnouncement = omitKeys(initialCreate, ["announcementID"]);

export type CreateInCalendarEvent = Omit<Create, "calendarEventID">;

export type CreateInCalendarEventRequiredKey = Exclude<CreateRequiredKey, "calendarEventID">;

export type CreateInCalendarEventSubset<K extends keyof CreateInCalendarEvent = keyof CreateInCalendarEvent> = Pick<
	CreateInCalendarEvent,
	CreateInCalendarEventRequiredKey | K
>;

export const blankItemInCalendarEvent: CreateInCalendarEvent = omitKeys(initialCreate, ["calendarEventID"]);

export type CreateInNewsletter = Omit<Create, "newsletterID">;

export type CreateInNewsletterRequiredKey = Exclude<CreateRequiredKey, "newsletterID">;

export type CreateInNewsletterSubset<K extends keyof CreateInNewsletter = keyof CreateInNewsletter> = Pick<
	CreateInNewsletter,
	CreateInNewsletterRequiredKey | K
>;

export const blankItemInNewsletter: CreateInNewsletter = omitKeys(initialCreate, ["newsletterID"]);

export type CreateInPost = Omit<Create, "postID">;

export type CreateInPostRequiredKey = Exclude<CreateRequiredKey, "postID">;

export type CreateInPostSubset<K extends keyof CreateInPost = keyof CreateInPost> = Pick<
	CreateInPost,
	CreateInPostRequiredKey | K
>;

export const blankItemInPost: CreateInPost = omitKeys(initialCreate, ["postID"]);

export type CreateInStudentNote = Omit<Create, "studentNoteID">;

export type CreateInStudentNoteRequiredKey = Exclude<CreateRequiredKey, "studentNoteID">;

export type CreateInStudentNoteSubset<K extends keyof CreateInStudentNote = keyof CreateInStudentNote> = Pick<
	CreateInStudentNote,
	CreateInStudentNoteRequiredKey | K
>;

export const blankItemInStudentNote: CreateInStudentNote = omitKeys(initialCreate, ["studentNoteID"]);
